
let paperProductLightbox = null;
let whiteProductLightbox = null;

(function () {
    const Url = location.protocol + '//' + location.host + '/wp-json/wp/v2/';

    class Geocoder {
        constructor() {
            this.urlBase = 'https://maps.googleapis.com/maps/api/geocode/json?address=';
            this.key = '&key=AIzaSyAiNO0CJPW0JJJnpsFiEZ-MCWKzRZQWkpE'
        }
        geocodeAddress(options) {
            let _this = this;
            let address = options.address;
            let value = this.urlBase + encodeURI(address) + this.key;
            jQuery(function () {
                //Call any jquery function
                jQuery.ajax({
                    type: 'POST',
                    url: GeocodeAjax.ajaxurl,
                    data: { 'action': 'geocode_map' },
                    dataType: 'json',
                    success: function (data) {
                        _this.setGeocodeAddress(JSON.parse(data), options.object)
                    } 
                });
            }); (jQuery); 
            /* fetch(value)
                .then(data => { return data.json() })
                .then(res => { _this.setGeocodeAddress(res, options.object) }) */
        }
        setGeocodeAddress(res, object) {
            if (res.status === 'OK') {
                object.map.setCenter(res.results[0].geometry.location);
            } else {
                alert('Address geocode was not successful for the following reason: ' + status);
            }
        }
        geocodeMarker(options) {
            let _this = this;
            //let address = options.address;
            //let value = this.urlBase + encodeURI(address) + this.key;
            let geocodeJson = options.object.geocodeInfo;
            //let postId = options.object.postId;
            let marker = options.object;
            _this.setGeocodeMarker(geocodeJson, marker);
            
        }
        setGeocodeMarker(res, object) {
            if (res.status === 'OK') {
                object.marker.setPosition(res.results[0].geometry.location);
            } else {
                alert('Address geocode was not successful for the following reason: ' + status);
            }
        }
    }

    class Retailer {
        /* ---
        Retailer objects:
                 
        -- */
        constructor(options) {
            this.address = options.locationinfo.address;
            this.marker = null;
            this.geocodeInfo = options.geocodeInfo;
            this.type = options.type;
            this.title = options.title;
            this.info = options.info;
            this.infoWindow = null;
            this.postId = options.id;
        }
        setMarker(retailerMap) {
            let _this = this;
            //create marker for Retailer object. 
            _this.marker = new google.maps.Marker({
                map: retailerMap.map,
                icon: { url: retailerMap.icon[_this.type],scaledSize: new google.maps.Size(40,40),},
                optimized: false,
                animation: google.maps.Animation.DROP,
                title: _this.title
            });
            //Geocode and display marker
            retailerMap.geocodeMarkerAddress(_this);
            //Create infowindow for Retailer with content from retailer object
            _this.infoWindow = new google.maps.InfoWindow({ content: '<div class="marker_info"><h2 class="marker_info__title">' + _this.title + '</h2><div class="marker_info__content">' + _this.info + '</div><div class="marker_info__address">'+_this.address+'</div></div>' })
            _this.marker.addListener('click', function() {
                //Get all retailers of retailerMap and close all associated infoWindows.
                retailerMap.retailers.map(data => data.infoWindow.close())
                //Open this marker's infoWindow
                _this.infoWindow.open(retailerMap, _this.marker);
            })
           
        }
        setMap(map) {
            this.marker.map = map;
        }
    }
    
    class RetailerMap {
        /*
        Retailer map object:
        Props:
        - List of retailer objects
        - Map center
        - Map styles
        - Map container selector
        - Map container DOM-object (when set)
        - Geocoder object
        - Active Type

        */
        constructor(options) {
            this.styles = options.styles;
            this.address = options.address;
            this.mapSelector = options.mapSelector;
            this.map = null;
            this.retailers = [];
            this.geocoder = new Geocoder;
            this.filter = options.filter;
            this.activeType = null;
            this.avaliableTypes = [];
            this.icon = {
                Restauranger: '/wp-content/themes/hallnas/assets/images/icon_pin_restaurant.svg',
                Butiker: '/wp-content/themes/hallnas/assets/images/icon_pin.svg'
            };
        }

        setRetailer(retailer) {
            let newRetailer = new Retailer({
                locationinfo: retailer.locationinfo,
                type: retailer.type,
                title: retailer.title.rendered,
                info: retailer.content.rendered,
                geocodeInfo: JSON.parse(retailer.geocodeInfo)
            });
            if (!this.avaliableTypes.includes(retailer.type)) this.avaliableTypes.push(retailer.type);
            this.retailers.push(newRetailer);
            newRetailer.setMarker(this);
        }

        getRetailers() {
            return this.retailers.filter(retailer => this.filterRetailerType(retailer));
        }

        filterRetailerType(retailer) {
            if (this.activeType) {
                return this.activeType.includes(retailer.type);
            } else {
                return true;
            }

        }

        instantiateMap() {
            this.map = new google.maps.Map(document.getElementById(this.mapSelector), {
                zoom: 5,
                gestureHandling: 'cooperative',
                scrollwheel: false,
                styles: this.styles
            });
            return true;
        }

        setFilter(filter) {
            this.retailers.map(retailer => retailer.setMap(null));
            this.activeType = [filter];
            let activeRetailers = this.getRetailers();
            activeRetailers.map(retailer => retailer.setMap(this.map));
        }

        clearFilter() {
            this.retailers.map(retailer => retailer.setMap(null));
            this.activeType = null;
            let activeRetailers = this.getRetailers();
            activeRetailers.map(retailer => retailer.setMap(this.map));
        }

        // Set the center of the map, by getting the supplied address and using the Google Maps Geocoder.
        geocodeAddress() {
            let activeMap = this;
            this.geocoder.geocodeAddress({ object: activeMap });
        }
        // Add markers to map
        geocodeMarkerAddress(retailer) {
            this.geocoder.geocodeMarker({ 'address': retailer.address, object: retailer });
        }

        loadRetailers(url) {
            let _this = this;
            let value = Url + 'hn-locations/?per_page=' + postNums.locations;
            fetch( value )
                .then(data => { return data.json() })
                .then(res => { res.map(location => _this.setRetailer(location)) });
        }
    }
    /* -- 
    -- classes: Array of classes to add to the lightbox object
    -- lightboxType; white or paper background
    --
    --- */
    class ProductLightbox {
        constructor(options) {
           
            this.boxElement = document.createElement('div');
            this.boxClasses = options.classes; // Styling classes
            this.lightboxType = options.lightboxType; // white or paper
            this.addClasses(this.boxClasses);
            this.instance = this;
            this.product = options.product;
            
        }
        addClasses(classes) {
            let _this = this;
            classes.map(newClass => _this.boxElement.classList.add(newClass));
        }
        
        populateBoxElement(product) {
            let _this = this;
            //Clear content of the box element
            _this.boxElement.innerHTML = '';
            //populate the wrapper with elements and append the wrapper to the box element
            let wrapper = document.createElement('div');
            wrapper.classList.add('product_lightbox__wrapper');
            let contentWrap = document.createElement('div');
            contentWrap.classList.add('product_lightbox__content_wrapper');
            let content = document.createElement('div');
            content.classList.add('product_lightbox__content');
            content.innerHTML = product.textContent;
            let title = document.createElement('h2');
            title.classList.add('product_lightbox__title');
            title.innerText = product.title;
            let image = document.createElement('img');
            if ( product.imageUrl ) {
                image.classList.add('product_lightbox__image');
                image.setAttribute('src', product.imageUrl);
            }
            let button = document.createElement('span');
            button.classList.add('product_lightbox__close_button');
            //Include eventlistener to close the lightbox
            _this.boxElement.addEventListener('click', function(event) {
                if ( event.target.classList.contains('product_lightbox--visible') ) {
                    _this.hideLightbox(_this);
                }
            })
            button.addEventListener('click', function() { _this.hideLightbox(_this) });
            contentWrap.appendChild(title)
            contentWrap.appendChild(content)
            if ( product.imageUrl ) wrapper.appendChild(image)
            wrapper.appendChild(contentWrap);
            wrapper.appendChild(button);
            this.boxElement.appendChild(wrapper);
            
        }
        displayLightbox(product) {
            this.populateBoxElement(product);
            document.body.appendChild(this.boxElement);
            this.boxElement.classList.remove('product_lightbox--hidden');
            this.boxElement.classList.add('product_lightbox--visible');
        }
        hideLightbox(lightboxElement) {
            if (lightboxElement.boxElement.classList.contains('product_lightbox--visible') ) {
                lightboxElement.boxElement.classList.add('product_lightbox--hidden');
                lightboxElement.boxElement.classList.remove('product_lightbox--visible');
                setTimeout(function() {
                    document.body.removeChild(lightboxElement.boxElement);
                }, 300);
                
            }
        }
    }
    class Product {
        constructor(options) {
            this.data = options.data;
            this.textContent = null;
            this.title = null;
            this.id = options.id;
            this.url = null;
            this.imageUrl = null;
            this.lightboxElement = null;
            this.lightboxType = options.background;
            this.loadFromData();
        }
        loadProduct(id) {
            let _this = this;
            fetch(Url + 'hn-product/'+id)
                .then(data => { return data.json() })
                .then(res => { _this.setValues(res) });
        }
        loadFromData() {
            this.setValues(this.data);
        }
        setValues(json) {
            this.textContent = json.content.rendered;
            this.title = json.title.rendered;
            this.url = json.link;
            this.imageUrl = json.imageUrl;
            this.lightboxElement = (this.lightboxType == 'white' ? whiteProductLightbox : paperProductLightbox );
        }
        displayProduct() {
            this.lightboxElement.displayLightbox(this);
        }
    }
    
    class ProductCollection {
        constructor(options) {
            this.elements = options.elements;

            this.loadProducts();
        }
        addProduct (product) {
            let _this = this;
            let element = _this.elements.find(element => parseInt(element.dataset.productId) === product.id);
            if (element) {
                let prod = new Product({ 'id': element.dataset.productId, 'background': element.dataset.backgroundType, 'data': product })
                element.addEventListener('click', function (event) {
                    event.preventDefault();
                    if (this.classList.contains('cycle-slide-active') || this.closest('.product_display').classList.contains('product_display--list') || this.closest('.product_display').classList.contains('product_display--text')) {
                        paperProductLightbox.hideLightbox(paperProductLightbox);
                        whiteProductLightbox.hideLightbox(whiteProductLightbox);
                        prod.displayProduct();
                    }
                })
            }
            
        }
        loadProducts() {
            let _this = this;
            fetch(Url + 'hn-product/?per_page=' + postNums.products)
                .then(data => { return data.json() })
                .then(res => { res.map(product => _this.addProduct(product)) });
        }
    }

    if ( document.getElementById('map-section') ) { 
        let activeMap = new RetailerMap({ mapSelector: 'map-section', address: 'Renmarkstorget 8, Umeå'});
        activeMap.instantiateMap();
        activeMap.loadRetailers();
        activeMap.geocodeAddress();
        if (document.getElementById('filter-butiker') ) {
            document.getElementById('filter-butiker').addEventListener('click', function(event) {
                event.preventDefault();
                activeMap.setFilter('Butiker')
            });
        }
        if (document.getElementById('filter-restauranger')) {
            document.getElementById('filter-restauranger').addEventListener('click', function (event) {
                event.preventDefault();
                activeMap.setFilter('Restauranger')
            });
        }
        if (document.getElementById('filter-all')) {
            document.getElementById('filter-all').addEventListener('click', function (event) {
                event.preventDefault();
                activeMap.clearFilter()
            });
        }
    }
    let productContainer = document.getElementsByClassName('product_display')
    if (productContainer) {
        paperProductLightbox = new ProductLightbox({ lightboxType: 'paper', classes: ['product_lightbox', 'product_lightbox--paper', 'product_lightbox--hidden'] })
        whiteProductLightbox = new ProductLightbox({ lightboxType: 'white', classes: ['product_lightbox', 'product_lightbox--white', 'product_lightbox--hidden'] })
        let products = document.getElementsByClassName('product_display__item')
        let productCollection = new ProductCollection({ 'elements': Array.from(products) });
    }
}());